import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { environment } from "src/environments/environment";
import { commonEnv } from "src/environments/environment.common";
import { EMSALStatus } from "./shared/auth/auth.model";

@Injectable({
  providedIn: "root",
})
export class MsalInitializerService {
  constructor(private msalService: MsalService) {}

  private getResetPasswordAuthority(): string {
    const currentAuthority = environment.msalConfig.auth.authority;
    const authorityParts = currentAuthority.split("/");

    if (authorityParts.length > 0) {
      authorityParts[authorityParts.length - 1] = commonEnv.resetPasswordPolicy;
      return authorityParts.join("/");
    }

    return currentAuthority;
  }

  private isResetRequiredError(error: any): boolean {
    const errorText = `${error?.errorCode || ""} ${error?.errorMessage || ""} ${error?.message || ""}`.toUpperCase();

    return (
      errorText.includes(EMSALStatus.FORGOT_PASSWORD) ||
      errorText.includes(EMSALStatus.PASSWORD_EXPIRED) ||
      errorText.includes("PASSWORD EXPIRED")
    );
  }

  initialize(): () => Promise<void> {
    return async () => {
      await this.msalService.instance.initialize();
      await this.msalService.instance
        .handleRedirectPromise()
        .then((response) => {
          if (response) {
            this.msalService.instance.setActiveAccount(response.account);
          }
        })
        .catch((error) => {
          console.error(error);

          if (this.isResetRequiredError(error)) {
            this.msalService.instance.loginRedirect({
              authority: this.getResetPasswordAuthority(),
              scopes: [...environment.apiConfig.scopes],
            });
          }
        });
    };
  }
}
